import { getBuffer } from "../getBuffer";

export const bufferToBase64 = (buf: Uint8Array): string => {
  const binstr = Array.prototype.map
    .call(buf, (ch: number) => String.fromCharCode(ch))
    .join('');
  return getBuffer().from(binstr, 'binary').toString('base64');
};
